var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_670_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06733 15.794V10.474H4.418V8.02934H6.06733V6.976C6.06733 4.25267 7.29933 2.99067 9.97267 2.99067C10.24 2.99067 10.6093 3.01867 10.9513 3.05934C11.2075 3.08569 11.4616 3.12912 11.712 3.18933V5.406C11.5672 5.3925 11.422 5.38449 11.2767 5.382C11.1138 5.37777 10.9509 5.37577 10.788 5.376C10.3167 5.376 9.94867 5.44 9.67133 5.582C9.48489 5.67554 9.32816 5.81912 9.21867 5.99667C9.04667 6.27667 8.96933 6.66 8.96933 7.16467V8.02934H11.582L11.3247 9.43134L11.1333 10.474H8.96933V15.9707C12.9307 15.492 16 12.1193 16 8.02934C16 3.61134 12.418 0.029335 8 0.029335C3.582 0.029335 0 3.61134 0 8.02934C0 11.7813 2.58267 14.9293 6.06733 15.794Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_670_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.09fb19fbe015c391efbb9b87833a9c12.svg";
export { ForwardRef as ReactComponent };